import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class Tenant extends Form {

    constructor(data = {}) {
        super(data);
    }
    
    index(append = false) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/tenant?page=' + self.page;

            axios.get(uri, self.data)
                .then(response => {
                    
                    let result = response.data;
                    self.processIndexData(result, append);

                    //self.tenants = response.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }



    createTenant() {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.post('/api/tenant', self.data)
                .then(response => {
                    self.setSuccessMessage('Tenant Created')
                    self.setFormUpdateComplete();

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }
}
